import { useBeeswaxInventorySources } from "@/modules/Beeswax/beeswax.hook";

export function useExchangeData({
  isEdit,
  areFilters,
}: {
  isEdit: boolean;
  areFilters: Record<string, boolean>;
}) {
  const {
    data: inventorySources,
    isLoading: inventorySourcesLoading,
    isFetching: inventorySourcesFetching,
  } = useBeeswaxInventorySources({
    queryParams: {
      page_size: 300,
      viewable: true,
    },
    options: { enabled: isEdit && areFilters?.inventory_source },
  });

  return {
    inventorySources,
    inventorySourcesLoading:
      inventorySourcesLoading && inventorySourcesFetching,
  };
}
